import React from 'react';

const About = () => {
  return (
    <section
      id="about"
      className="py-16 px-8 lg:px-32"
      style={{ 
        fontFamily: "'EB Garamond', serif", 
        backgroundColor: "#f7f6ef"
      }}
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-12">
          {/* Left Column */}
          <div>
            <p className="text-base sm:text-lg md:text-xl text-gray-900 leading-relaxed">
              <strong className="font-semibold text-lg sm:text-xl md:text-2xl">Sally Heath</strong> was born into a family of musicians in Chiswick, London. She studied at the Royal College of Music where she won the Concerto Prize with a performance of Beethoven's 1st piano concerto.
            </p>
            <p className="mt-4 text-base sm:text-lg md:text-xl text-gray-900 leading-relaxed">
              After a postgraduate course at the Guildhall School of Music and Drama, she was offered a position as an accompanist for both junior and senior departments. Here, Sally formed a trio with clarinettist Joan Lluna and cellist Nick Roberts, appearing frequently in Spain and broadcasting live as part of the Barcelona Festival. Her chamber career flourished and she joined the London Metropolitan Ensemble, with whom she gave a Wigmore Hall concert and a classic FM broadcast.
            </p>
            <p className="mt-4 text-base sm:text-lg md:text-xl text-gray-900 leading-relaxed">
              In the early 2000's, Sally took part in the Weybridge Festival with chamber works by Brahms, Mozart, Faure and Alan Rawsthorne. Her fellow musicians included violinist David Juritz, and cellist, Caroline Dale. As part of the festival also she performed Mozart piano concerto K488 and a Chopin 'words and music' evening. Her love of Chopin led to an invitation to play for the Chopin Society in 1994.
            </p>
          </div>
          {/* Right Column */}
          <div>
            <p className="text-base sm:text-lg md:text-xl text-gray-900 leading-relaxed">
              As well as her solo and chamber appearances, Sally is a member of the London Metropolitan Orchestra, playing on film and TV soundtracks such as Inspector Morse, Lewis, Hilary and Jackie, Truly Madly Deeply and more recently, The Young Victoria, Still Alice, Shaun the Sheep and Florence Foster Jenkins.
            </p>
            <p className="mt-4 text-base sm:text-lg md:text-xl text-gray-900 leading-relaxed">
            Sally is a teacher and accompanist in South West London, teaching piano and violin both privately and in schools.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
